/**
 * @fileoverview CSS module for rendering date input questions
 * Provides styles for date input fields, error states, and responsive layouts
 *
 * @example
 * // Usage in component:
 * import styles from './DateRenderer.module.css';
 *
 * <div className={styles.container}>
 *   <div className={styles.group}>
 *     <input className={styles.month} type="text" />
 *     <input className={styles.day} type="text" />
 *     <input className={styles.year} type="text" />
 *   </div>
 * </div>
 */


.container {
    display: flex;
    gap: 0.5rem;
    flex-direction: column;
}

.group {
    display: flex;
    gap: 0.5rem;
}

.month {
    flex-grow: 2;
}

.year {
    flex-grow: 1;
}

.day {
    flex-grow: 1;
}

.errorMessage {
    margin-top: 1rem;
    margin-bottom: 1rem;
    color: var(--red700);
}

@media (min-width: 768px) {
    .container {
        flex-direction: row;
    }

    .group {
        flex-direction: row;
        flex-grow: 2;
    }
}
